import { render, staticRenderFns } from "./PermissionTypeSelector.vue?vue&type=template&id=40acbb68&"
import script from "./PermissionTypeSelector.vue?vue&type=script&lang=js&"
export * from "./PermissionTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports